export const PAY_INVOICE_SUCCEEDED = 'PAY_INVOICE_SUCCEEDED';
